import axios from 'axios';

const api = axios.create({
//baseURL: 'http://localhost:5009',
baseURL: 'https://newlightning-b6bf11a63034.herokuapp.com',
  withCredentials: true,
});

// Attach access token to EVERY request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('accessToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`; 
  }
  return config;
});

export default api;
